export enum LinksErrorCodes {
  AccountNotVerified="AccountNotVerified",
}

export const DEFAULT_ERROR = "Could not add link, please try again later";
export const VERIFIED_ERROR = "Alias Links are only available to verified creators at this time";
